<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-08 14:26:08
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:24:09
 * @Description: file content
 来源
 -->
 <template>
  <div class="container">
    <span class="source">
      <span class="label">来源：</span>
      <span class="value">{{pageInfo.Wxaccountname || "很多客"}}</span>
    </span>
    <span class="reference">
      <span class="label">引用：</span>
      <span class="value">{{pageInfo.Actname || "小原"}}</span>
    </span>
  </div>
</template>
 
 <script>
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
 <style lang="css" scoped>
.container {
  margin: 0.3rem;
  color: #999999;
  font-size: 12px;
  margin-bottom: 0;
}
.source {
  margin-right: 10px;
}
</style>
